<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">Edit {{dialogData.user_type}}</h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content">
        <form action="" [formGroup]="editUser" (ngSubmit)="onSubmit()">
            <span class="profile-box">
                <div class="profile-img mt-3 mt-lg-4" *ngIf="!imagePath"
                    [appBackgroundImg]="dialogData.data.profile_picture" [iType]="userType">
                    <ng-container *ngTemplateOutlet="chooseFile"></ng-container>
                </div>
                <div class="profile-img mt-3 mt-lg-4" *ngIf="imagePath"
                    [style.backgroundImage]="'url('+ imagePath +')'">
                    <ng-container *ngTemplateOutlet="chooseFile"></ng-container>
                </div>
            </span>

            <ng-template #chooseFile>
                <div class="profile-edit-icon d-flex align-items-center justify-content-center"
                    (click)="fileInput.click()">
                    <i class="material-icons">mode_edit</i>
                    <input #fileInput type="file" formControlName="profile_picture"
                        (change)="onProfilePicChange($event)" accept=".png, .jpg, .jpeg" style="display:none" />
                </div>
            </ng-template>

            <div class="row">
                <div class="col-xl-6 mt-3 mt-3 mt-lg-4">
                    <label for="">First Name</label>
                    <div class="form-input">
                        <input type="text" class="form-control" placeholder="First name" formControlName="first_name">
                        <i class="fas fa-user material-icons"></i>
                    </div>
                    <mat-error *ngIf="isControlHasError('first_name','required')"> {{"First Name is required"|translate}} </mat-error>
                </div>
                <div class="col-xl-6 mt-3 mt-lg-4">
                    <label for="">Last Name</label>
                    <div class="form-input">
                        <input type="text" class="form-control" placeholder="Last name" formControlName="last_name">
                        <i class="fas fa-user material-icons"></i>
                    </div>
                    <mat-error *ngIf="isControlHasError('last_name','required')"> Last Name is required </mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-6 mt-3 mt-3 mt-lg-4">
                    <label for="">Email</label>
                    <div class="form-input">
                        <input type="text" class="form-control" placeholder="{{'abc@gmail.com' | translate}}"
                            formControlName="email" [readOnly]="true">
                        <img src="assets/images/icons/website.png" class="img-fluid material-icons" alt="">
                    </div>
                    <mat-error *ngIf="isControlHasError('email','required')"> Email is required</mat-error>
                </div>
                <div class="col-xl-6 mt-3 mt-lg-4">
                    <label for="">Phone Number</label>
                    <div class="form-input">
                        <input type="tel" class="form-control" placeholder="+1 12345 67890"
                            formControlName="phone_number">
                        <img src="assets/images/icons/phone.svg" class="img-fluid material-icons">
                    </div>
                </div>
            </div>
            <!-- <div class="row" *ngIf="dialogData.user_type=='Manager'"> -->
            <div class="row">
                <div class="col-xl-6 mt-3 mt-3 mt-lg-4">
                    <label for="">Password</label>
                    <div class="form-input">
                        <input type="{{isShowPassword ? 'text' : 'password'}}" class="form-control"
                            placeholder="Enter password" formControlName="password">
                        <img src="assets/images/icons/pwd.svg" class="img-fluid material-icons">
                        <img src="assets/images/icons/eye.svg" *ngIf="isShowPassword"
                            class="img-fluid  eye-icon pointer" (click)="toggleShowPassword('password')">
                        <img src="assets/images/icons/eye_cancel.svg" *ngIf="!isShowPassword"
                            class="img-fluid  eye-icon pointer" (click)="toggleShowPassword('password')">
                    </div>
                    <mat-error *ngIf="isControlHasError('password','required')"> Password is required </mat-error>
                    <mat-error *ngIf="isControlHasError('password','minlength')"> Password length should be more than 8
                        characters </mat-error>
                </div>
                <div class="col-xl-6 mt-3 mt-lg-4">
                    <label for="">Confirm Password</label>
                    <div class="form-input">
                        <input type="{{isShowCPassword ? 'text' : 'password'}}" class="form-control"
                            placeholder="Enter confirm password" formControlName="confirm_password">
                        <img src="assets/images/icons/cpwd.svg" class="img-fluid material-icons">
                        <img src="assets/images/icons/eye.svg" *ngIf="isShowCPassword"
                            class="img-fluid  eye-icon pointer" (click)="toggleShowPassword('confirm_password')">
                        <img src="assets/images/icons/eye_cancel.svg" *ngIf="!isShowCPassword"
                            class="img-fluid  eye-icon pointer" (click)="toggleShowPassword('confirm_password')">
                    </div>
                    <mat-error *ngIf="isControlHasError('confirm_password','required')">Confirm Password is required
                    </mat-error>
                    <mat-error *ngIf="isControlHasError('confirm_password','passwordNotMatch')">Cdoes not matchd
                    </mat-error>
                </div>

                
           

            </div>
            <div class="row mb-2">
                <div class="col-12 mt-3 mt-lg-4">
                    <label for="">Department</label>
                    <mat-select multiple formControlName="department" class="form-control"
                        placeholder="Select Department">
                        <mat-option *ngFor="let data of departmentData" [value]="data.cd_i">
                            {{ data.dep }}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
        </form>

         <div class="mt-3 d-flex flex-wrap gap-2" *ngIf="this.dialogData.user_type == 'Manager' ">
            <mat-checkbox class="c-check-box" 
            [(ngModel)]="isSelectedAll" (change)="toggleSelectAll()">
              <div class="text-wrap">Select all</div>
          </mat-checkbox>
            <mat-checkbox class="c-check-box" 
            [(ngModel)]="selectedAccessKeys[i]" 
            *ngFor="let item of managerAccessListArray; let i = index">
              <div class="text-wrap">{{ item.access_value }}</div>
              <!-- <div *ngIf="userAccessKeys.includes(item.access_key)" class="text-wrap">{{ item.access_key }}</div> -->
          </mat-checkbox>
              </div>

    </div>
    <div class="row item-footer">
        <div class="col-md-6 m-auto mt-xl-2">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4 " type="submit"
                (click)="onSubmit()">{{"Save"|translate}}</button>
        </div>
    </div>
</div>


<app-loading-spinner></app-loading-spinner>